<script>
import { ElMessage } from "element-plus";
import SparkMD5 from "spark-md5";
import axios from "axios";
import { v4 as uuid4v } from "uuid";
import { useStore } from "vuex";

export default {
  setup() {},

  data() {
    return {
      productFrom: {
        name: "",
        model: "",
        brandName: "",
        brand: "",
        description: "",
        type: "",
        modelFeature: "",
        keywords: "",
        features: "",
        featureList: [],
        applications: "",
        applicationList: [],
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        brand: [{ required: true, message: "请选择", trigger: "change" }],
        model: [{ required: true, message: "请输入型号", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
      },
      files: [[], [], []],
      typeOptions: [],
      brandOptions: [],
      id: "",
      subcategory: "",
      attachNo: "",
      attachmentId: "",
      fileData: {
        id: "",
        path: "",
        oldId: "",
        oldPath: "",
        status: "",
      },
      title: "",
      dialogVisible: false,
      dialogImageUrl: "",
      stabValue: 4,
      store: useStore(),
      canChannge: false,
      fileList: [],
      urls: [[], [], []],
      islook: false,
      filekey: false,
      paths: [],
      bannerPath: "",
      wenTile: "",
      wenContent: "",
      brn: "",
    };
  },
  mounted() {
    const user = this.store.state.userInfo;
    this.canChannge = user
      ? user.permission
        ? user.permission == 0 || user.permission == 1
        : false
      : false;
    this.id = this.$route.query.id;
    this.brandType = this.$route.query.type;
    this.bannerPath =
      this.brandType == 1
        ? require("../../assets/about.jpg")
        : this.brandType == 2
        ? "https://omo-oss-image.thefastimg.com/portal-saas/new2023021809352291162/cms/image/a8e9c72f-c009-49b2-b25d-bc1dde486fe6.jpg"
        : this.brandType == 3
        ? require("../../assets/jxsbs.png")
        : require("../../assets/yqybbj.png");
    this.wenTile =
      this.brandType == 1
        ? "配电与自动化元件"
        : this.brandType == 2
        ? "清洁系统"
        : this.brandType == 3
        ? "工业机器人"
        : "仪器仪表";
    this.brn = this.brandType == 3 ? "大类：" : "品牌：";
    this.wenContent = this.brandType == 3 ? "开箱装箱打标封箱码垛AGV叉车" : "";
    this.title = this.canChannge ? (this.id ? "修改" : "新增") : "详情";
    if (this.id) {
      this.getDetail();
    } else {
      this.attachNo = uuid4v();
    }

    this.queryBrands();
  },
  methods: {
    getDetail() {
      // 提交数据到接口
      axios
        .get("/product/get", {
          params: { Id: this.id },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            ElMessage.success("数据获取成功");
            this.attachmentId = response.data.data.attachmentId;
            this.productFrom.name = response.data.data.name;
            this.productFrom.model = response.data.data.model;
            this.productFrom.brandName = response.data.data.brand;
            this.productFrom.brand = response.data.data.brandId;
            this.productFrom.description = response.data.data.description;
            this.productFrom.type = response.data.data.typeId;
            this.productFrom.modelFeature = response.data.data.modelSpecifications;
            this.productFrom.keywords = response.data.data.keywords;
            this.productFrom.features = response.data.data.features;
            this.productFrom.featureList = response.data.data.features
              ? response.data.data.features.split("\n")
              : [];
            this.productFrom.applications = response.data.data.applications;
            this.productFrom.applicationList = response.data.data.applications
              ? response.data.data.applications.split("\n")
              : [];
            this.attachNo = response.data.data.attachNo;
            if (response.data.data.attachmentVoList) {
              response.data.data.attachmentVoList.forEach((vo) => {
                if (!vo.subcategorySon) {
                  this.fileData.id = vo.id;
                  this.fileData.oldId = vo.id;
                  this.fileData.path = vo.path;
                  this.fileData.oldPath = vo.path;
                  this.fileData.status = vo.status;
                } else {
                  this.files[vo.subcategorySon - 1].push({
                    id: vo.id,
                    name: vo.originalName,
                    url: vo.path,
                    sno: vo.sno,
                    subcategory: vo.subcategory,
                  });
                  this.urls[vo.subcategorySon - 1].push(vo.path);
                }
              });
              this.createPaths();
              this.stabValue = this.getStabValue();
            }
            this.queryTypes();
          } else {
            ElMessage.error("数据获取失败：" + response.data.description);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("数据获取失败：", error);
        });
    },
    createPaths() {
      if (this.urls[0] && this.urls[0].length > 0) {
        this.urls[0].forEach((vo) => {
          this.paths.push(vo);
        });
      }
      if (this.urls[1] && this.urls[1].length > 0) {
        this.urls[1].forEach((vo) => {
          this.paths.push(vo);
        });
      }
      if (this.urls[2] && this.urls[2].length > 0) {
        this.urls[2].forEach((vo) => {
          this.paths.push(vo);
        });
      }
    },
    getStabValue() {
      if (this.files[0].length > 0) {
        return 1;
      } else if (this.files[1].length > 0) {
        return 2;
      } else if (this.files[2].length > 0) {
        return 3;
      }
      return 4;
    },
    queryTypes() {
      if (this.productFrom.brand) {
        const typeDto = {
          brandId: this.productFrom.brand,
        };
        // 提交数据到接口
        axios
          .post("/productType/query", typeDto, {
            Headers: {
              "Content-Type": "application/json;charset=utf-8",
            },
          }) // 使用创建的api实例: api.post('/your-endpoint', payload)
          .then((response) => {
            // 处理接口返回的结果
            if (response.data.code === 200) {
              this.typeOptions = response.data.data;
            } else {
              this.typeOptions = [];
              ElMessage.error("请求失败" + response.data.description);
            }
          })
          .catch((error) => {
            // 处理请求错误
            ElMessage.error("请求失败，请检查网络或接口地址");
            console.error("提交失败：", error);
          });
      } else {
        this.typeOptions = [];
      }
    },
    queryBrands() {
      axios
        .get("/brand/query", {
          params: { type: this.brandType },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            this.brandOptions = response.data.data;
          } else {
            ElMessage.error("请求失败" + response.data.description);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("提交失败：", error);
        });
    },
    brandChange(value) {
      if (value) {
        this.productFrom.brand = value;
      } else {
        this.productFrom.brand = "";
      }
      this.queryTypes();
    },
    async beforeUpload(file) {
      if (!file) {
        this.$message.error("文件丢失取消上传");
        return false;
      } else if (file.size / 1024 / 1024 > 50) {
        this.$message.error("文件不能大雨50M");
        return false;
      }
      try {
        var fileReader = new FileReader();
        //获取文件二进制数据
        fileReader.readAsArrayBuffer(file);
        const spark = new SparkMD5.ArrayBuffer();
        fileReader.onload = async (e) => {
          spark.append(e.target.result);
          this.MD5 = spark.end();
          this.localUpload(file, this.MD5);
        };
      } catch (error) {
        console.error("计算MD5值有误：", error);
        return false;
      }
      return false;
    },
    //上传文件到本地服务器
    localUpload(file, MD5) {
      const fileType = file.name.split(".")[1];
      const formData = new FormData();
      formData.append("file", file);
      formData.append("md5", MD5);
      formData.append("category", "product");
      formData.append("size", file.size);
      formData.append("originalName", file.name);
      formData.append("type", fileType);
      formData.append("method", 0);
      formData.append("attachNo", this.attachNo);
      if (this.stabValue == 0) {
        formData.append("oldId", this.fileData.oldId);
        formData.append("oldPath", this.fileData.oldPath);
        formData.append("id", this.fileData.id);
      }
      formData.append("status", this.fileData.status);
      formData.append("subcategory", this.subcategory);
      // 提交数据到接口
      axios
        .post("/attachment/localUpload", formData, {
          Headers: {
            "Content-Type": "multipart/form-data",
          },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结果
          if (response.data.code === 200) {
            ElMessage.success("提交成功");
            if (this.stabValue == 0) {
              this.attachmentId = response.data.data.id;
              this.fileData.id = response.data.data.id;
              this.fileData.oldId = response.data.data.id;
              this.fileData.path = response.data.data.path;
              this.fileData.oldPath = response.data.data.path;
              this.fileData.status = 2;
            } else {
              this.files[this.stabValue - 1].push({
                id: response.data.data.id,
                name: response.data.data.originalName,
                subcategory: response.data.data.subcategory,
                url: response.data.data.path,
                sno: response.data.data.sno,
              });
              this.urls[this.stabValue - 1].push(response.data.data.path);
              this.paths = [];
              this.createPaths();
              this.filekey = !this.filekey;
            }
          } else {
            ElMessage.error("提交失败：" + response.data.message);
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("提交失败：", error);
        });
    },
    typeChange(value) {
      this.productFrom.type = value[value.length - 1];
    },
    stab(value) {
      this.stabValue = value;
      let index = 0;
      if (value == 0) {
        this.subcategory = "";
      }
      if (value == 1) {
        this.subcategory = "feature";
        index = 1;
      }
      if (value == 2) {
        this.subcategory = "apply";
        index = this.urls[0] ? this.urls[0].length + 1 : 1;
      }
      if (value == 3) {
        this.subcategory = "cansu";
        index = this.urls[1]
          ? this.urls[0]
            ? this.urls[0].length + this.urls[1].length + 1
            : this.urls[1].length + 1
          : 1;
      }
      if (!this.canChannge) {
        const contaier = document.querySelector(`.image-container:nth-child(${index})`);
        contaier.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    },
    deleteProduct() {
      this.$confirm("此操作将提交下架产品审核, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 提交数据到接口
          axios
            .get("/product/delete", {
              params: { Id: this.id, attachNo: this.attachNo },
            }) // 使用创建的api实例: api.post('/your-endpoint', payload)
            .then((response) => {
              // 处理接口返回的结果
              if (response.data.code === 200) {
                this.$message({
                  type: "success",
                  message: "产品下架成功!",
                });
                this.$router.push("/ProductPage?type=" + this.brandType);
              } else {
                ElMessage.error("产品下架失败：" + response.data.description);
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("产品下架失败：", error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消提交下架审核",
          });
        });
    },
    returnProductsPage() {
      this.$router.push("/ProductPage?type=" + this.brandType);
    },
    submitProduct(Ref) {
      this.$refs[Ref].validate((valid) => {
        if (valid) {
          // this.$confirm("将产品提交上架、变更审核, 是否继续?", "提示", {
          //   confirmButtonText: "确定",
          //   cancelButtonText: "取消",
          //   type: "warning",
          // })
          //   .then(() => {
          if (this.productFrom.brand) {
            this.productFrom.brandName = this.brandOptions.filter(
              (item) => item.id == this.productFrom.brand
            )[0].name;
          }
          const productDto = {
            id: this.id,
            status: 1,
            name: this.productFrom.name,
            attachmentId: this.attachmentId,
            features: this.productFrom.features,
            applications: this.productFrom.applications,
            model: this.productFrom.model,
            brand: this.productFrom.brandName,
            brandId: this.productFrom.brand,
            description: this.productFrom.description,
            typeId: this.productFrom.type,
            keywords: this.productFrom.keywords,
            modelSpecifications: this.productFrom.modelFeature,
            attachNo: this.attachNo,
          };
          // 提交数据到接口
          axios
            .post("/product/save", productDto, {
              Headers: {
                "Content-Type": "application/json;charset=utf-8",
              },
            }) // 使用创建的api实例: api.post('/your-endpoint', payload)
            .then((response) => {
              // 处理接口返回的结果
              if (response.data.code === 200) {
                this.$router.push("/ProductPage?type=" + this.brandType);
              } else if (response.data.code === 1019) {
                ElMessage.error("产品上架失败," + response.data.description);
              } else {
                ElMessage.error("产品上架失败," + response.data.message);
              }
            })
            .catch((error) => {
              // 处理请求错误
              ElMessage.error("请求失败，请检查网络或接口地址");
              console.error("产品上架失败", error);
            });
          // })
          // .catch(() => {
          //   this.$message({
          //     type: "info",
          //     message: "已取消提交审核。",
          //   });
          // });
        } else {
          ElMessage.error("请填写所有必填项");
        }
      });
    },
    async beforeRemove(file) {
      console.log(file);
      if (file.status && file.status == "ready") {
        return false;
      }
      return await this.$confirm("此操作将移除图片, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {})
        .catch(() => {
          return false;
        });
    },
    handlePictureCardPreview(file) {
      this.dialogVisible = true;
      this.dialogImageUrl = file.url;
    },
    hoverRemove(file) {
      axios
        .get("/attachment/delete", {
          params: {
            id: file.id,
            url: file.url,
            subcategory: file.subcategory,
            no: this.attachNo,
            sno: file.sno,
          },
        }) // 使用创建的api实例: api.post('/your-endpoint', payload)
        .then((response) => {
          // 处理接口返回的结
          if (response.data.code === 200) {
            (this.files[this.stabValue - 1] = []), (this.urls[this.stabValue - 1] = []);
            response.data.data.forEach((vo) => {
              this.files[vo.subcategorySon - 1].push({
                id: vo.id,
                name: vo.originalName,
                url: vo.path,
                sno: vo.sno,
                subcategory: vo.subcategory,
              });
              this.urls[vo.subcategorySon - 1].push(vo.path);
            });
            this.paths = [];
            this.createPaths();

            this.filekey = !this.filekey;
            ElMessage.success("附件移除成功");
          }
        })
        .catch((error) => {
          // 处理请求错误
          ElMessage.error("请求失败，请检查网络或接口地址");
          console.error("文件移除失败", error);
        });
    },
    look() {
      this.islook = true;
      this.canChannge = false;
      this.title = "详情";
      this.productFrom.featureList = this.productFrom.features
        ? this.productFrom.features.split("\n")
        : [];
      this.productFrom.applicationList = this.productFrom.applications
        ? this.productFrom.applications.split("\n")
        : [];
    },
    nolook() {
      this.islook = false;
      this.canChannge = true;
      this.title = this.id ? "修改" : "新增";
    },
  },
};
</script>
<template>
  <div class="Product_banner">
    <div>
      <img :src="this.bannerPath" />
      <div class="product_wen">
        <div class="product_wen_title">{{ this.wenTile }}</div>
        <div class="product_wen_content">{{ this.wenContent }}</div>
      </div>
    </div>
  </div>
  <div class="contaier product">
    <div class="inner">
      <div class="content_title">
        <div class="flex title1">
          <div class="flex-item left">
            <span class="line_"></span>
          </div>
          <div class="text">
            <span>产品</span>
            <span class="red">{{ this.title }}</span>
          </div>
          <div class="flex-item right">
            <span class="line_"></span>
          </div>
        </div>
      </div>
      <div class="productDetailPannel">
        <div class="fileImg" @click="stab(0)">
          <el-upload
            v-if="this.canChannge"
            :limit="1"
            :before-upload="beforeUpload"
            :data="this.fileData"
            action="attachment/localUpload"
            class="avatar-uploader"
            accept=".png,.jpg,.jpeg,.gif"
          >
            <img v-if="this.fileData.path" :src="this.fileData.path" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <div
            style="
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            "
          >
            <img
              v-if="!this.canChannge && this.fileData.path"
              :src="this.fileData.path"
            />
            <img
              v-if="!this.canChannge && !this.fileData.path"
              src="../../assets/wutup.jpg"
            />
          </div>
        </div>
        <div class="productF">
          <el-form :model="productFrom" :rules="rules" ref="productFrom">
            <el-form-item label="名称：" prop="name" label-width="120px">
              <el-input
                v-if="this.canChannge"
                v-model="productFrom.name"
                placeholder="请输入名称"
              />
              <span v-else class="miaosu">{{ this.productFrom.name }}</span>
            </el-form-item>
            <el-form-item label="型号：" prop="model" label-width="120px">
              <el-input
                v-if="this.canChannge"
                v-model="productFrom.model"
                placeholder="请输入型号"
              />
              <span v-else class="miaosu">{{ this.productFrom.model }}</span>
            </el-form-item>

            <el-form-item :label="this.brn" prop="brand" label-width="120px">
              <el-select
                :disabled="!this.canChannge"
                v-model="productFrom.brand"
                @change="brandChange"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="brand in brandOptions"
                  :key="brand.id"
                  :label="brand.name"
                  :value="brand.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="类型：" prop="type" label-width="120px">
              <el-cascader
                :disabled="!this.canChannge"
                v-model="productFrom.type"
                :options="typeOptions"
                @change="typeChange"
                clearable
                placeholder="请选择类型"
                style="width: 580px"
              >
              </el-cascader>
            </el-form-item>
            <el-form-item label="简介：" prop="description" label-width="120px">
              <el-input
                v-if="this.canChannge"
                v-model="productFrom.description"
                type="textarea"
                :rows="5"
                placeholder="请输入简介"
              />
              <span v-else class="miaosu">{{ this.productFrom.description }}</span>
            </el-form-item>

            <el-form-item label="关键词：" prop="keywords" label-width="120px">
              <el-input
                v-if="this.canChannge"
                v-model="productFrom.keywords"
                placeholder="请输入关键词"
              />
              <span v-else class="miaosu">{{ this.productFrom.keywords }}</span>
            </el-form-item>
            <el-form-item label="型号特征：" prop="modelFeature" label-width="120px">
              <el-input
                v-if="this.canChannge"
                v-model="productFrom.modelFeature"
                type="textarea"
                :rows="3"
                placeholder="型号特征"
              />
              <span v-else class="miaosu">{{ this.productFrom.modelFeature }}</span>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="detail">
        <div class="detail_title">
          <div
            v-if="
              this.canChannge ||
              this.productFrom.features ||
              (this.files[0] && this.files[0].length != 0)
            "
          >
            <div v-if="this.stabValue == 1" class="tab_item changeing" @click="stab(1)">
              产品特点
            </div>
            <div v-if="this.stabValue != 1" class="tab_item" @click="stab(1)">
              产品特点
            </div>
          </div>
          <div
            v-if="
              this.canChannge ||
              this.productFrom.applications ||
              (this.files[1] && this.files[1].length != 0)
            "
          >
            <div v-if="this.stabValue == 2" class="tab_item changeing" @click="stab(2)">
              产品应用
            </div>
            <div v-if="this.stabValue != 2" class="tab_item" @click="stab(2)">
              产品应用
            </div>
          </div>
          <div v-if="this.canChannge || (this.files[2] && this.files[2].length != 0)">
            <div v-if="this.stabValue == 3" class="tab_item changeing" @click="stab(3)">
              技术参数
            </div>
            <div v-if="this.stabValue != 3" class="tab_item" @click="stab(3)">
              技术参数
            </div>
          </div>
        </div>
        <div class="detail_content">
          <div class="inp" v-if="this.stabValue == 1">
            <el-input
              v-if="this.canChannge"
              v-model="productFrom.features"
              type="textarea"
              :rows="5"
              placeholder="请输入产品特点"
            />
            <span v-else class="miaosu">
              <div v-for="str in this.productFrom.featureList" :key="str">
                {{ str }}
              </div>
            </span>
            <!-- :autosize="{ minRows:5}" 可根据内容扩充输入框 -->
          </div>
          <div class="inp" v-if="this.stabValue == 2">
            <el-input
              v-if="this.canChannge"
              v-model="productFrom.applications"
              type="textarea"
              :rows="5"
              placeholder="请输入应用"
            /><!-- :autosize="{ minRows:5}" 可根据内容扩充输入框 -->
            <span v-else class="miaosu">
              <div v-for="str in this.productFrom.applicationList" :key="str">
                {{ str }}
              </div>
            </span>
          </div>
          <div
            class="detail_img"
            v-if="this.stabValue == 1 || this.stabValue == 2 || this.stabValue == 3"
          >
            <el-upload
              v-if="this.canChannge"
              :key="filekey"
              list-type="picture-card"
              :before-upload="beforeUpload"
              :file-list="this.files[this.stabValue - 1]"
              action="file/path"
              accept=".png,.jpg,.jpeg,.gif"
              :on-preview="handlePictureCardPreview"
              :before-remove="beforeRemove"
              :on-remove="hoverRemove"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <div class="demo-image__lazy" v-if="!this.canChannge && this.paths">
              <div
                v-for="(url, index) in this.paths"
                :key="index"
                class="image-container"
              >
                <el-image :src="url" lazy></el-image>
              </div>
            </div>
            <el-dialog v-model="dialogVisible" width="60%">
              <img width="100%" :src="this.dialogImageUrl" alt="" />
            </el-dialog>
          </div>
        </div>
      </div>
      <div class="footerBtn" v-if="this.canChannge">
        <span class="dialog-footer">
          <el-button v-if="this.id" class="delete" @click="deleteProduct">下架</el-button>
          <el-button @click="returnProductsPage()">返回</el-button>
          <el-button @click="look()">预览</el-button>
          <el-button type="primary" @click="submitProduct('productFrom')"
            >确认提交</el-button
          >
        </span>
      </div>
      <div class="footerBtn" v-if="this.islook">
        <span class="dialog-footer">
          <el-button @click="nolook()">取消预览</el-button>
        </span>
      </div>
    </div>
  </div>
</template>
<script></script>
<style>
.fileImg {
  width: 45%;
  height: 480px;
  padding-left: 40px;
}
.fileImg i {
  font-size: 28px;
  color: #8c939d;
  width: 630px;
  height: 440px;
  line-height: 480px;
  text-align: center;
}
.fileImg img {
  /* width: 630px; */
  /* height: 440px; */
  width: 92%;
  max-height: 450px;
  display: block;
  padding-left: 10px;
  padding-top: 10px;
  padding-right: 10px;
}
.productDetailPannel {
  padding-top: 20px;
  display: flex;
  padding-bottom: 10px;
}
.productF {
  width: 46%;
  height: 480px;
}
.detail .detail_title {
  display: flex;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #b5b5b5;
}
.detail .detail_title .tab_item {
  font-size: 16px;
  color: #575555;
  text-align: center;
  cursor: pointer;
  margin-left: 30px;
  width: 100px;
}
.detail .detail_title .tab_item:hover {
  font-size: 18px;
  border-bottom: 2px solid #3d3d3d;
}
.changeing {
  font-size: 18px;
  border-bottom: 2px solid #3d3d3d;
}
.detail .detail_content {
  padding-top: 10px;
  padding-bottom: 10px;
}
.detail_content .inp {
    width: 96%;
    line-height: 30px;
    padding-left: 30px;
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 4px;
}
.detail_img {
  width: 98%;
  text-align: center;
  padding-bottom: 10px;
}
/* .detail_img i {
  font-size: 28px;
  color: #8c939d;
  width: 1500px;
  height: 600px;
  line-height: 600px;
  text-align: center;
} */
.detail_img img {
  width: 800px;
  display: block;
  margin: auto;
  object-fit: contain;
}
.footerBtn {
  height: 80px;
  line-height: 80px;
  padding-left: 35%;
}
.footerBtn button {
  padding-left: 40px;
  padding-right: 40px;
  margin-left: 30px;
  margin-right: 30px;
  height: 40px;
}
</style>
